export default __webpack_public_path__ + "static/media/icon_admin_guide.0e212bff.svg";